angular = require('angular')
pkg = angular
  .module 'common.menu', []
  .directive "menuAside", require("./aside")
  .directive "menuHeader", require("./header")
  
module.exports = pkg.name


// WEBPACK FOOTER //
// ./src/component/menu/index.coffee